import OptionForm from './OptionForm'
import { withOptionForm } from './withOptionForm'

const ConnectedOptionForm = withOptionForm(OptionForm)

export { ConnectedOptionForm as OptionForm }
